/**
 * AimsDocPage - Renders an AIMS documentation page by path.
 */
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import Layout from "../components/Layout";
import DocSidebar from "../components/DocSidebar";
import DocContent from "../components/DocContent";
import AIMS_CONTENT_MAP from "../data/aimsContentMap";
import { AIMS_TOC } from "../data/aimsToc";

const BASE_PATH = "/docs/aims-dmg";

export default function AimsDocPage() {
  const { "*": path } = useParams();
  const normalizedPath = path || "introduction";

  const content = AIMS_CONTENT_MAP[normalizedPath];

  if (!content) {
    return <Navigate to={BASE_PATH} replace />;
  }

  return (
    <Layout
      sidebar={
        <DocSidebar
          basePath={BASE_PATH}
          toc={AIMS_TOC}
          backLabel="← AIMS Data Model Generator"
        />
      }
      showSidebar={true}
    >
      <article className="max-w-4xl">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 border-b border-gray-200 dark:border-gray-700 pb-4">
            {content.title}
          </h1>
        </header>
        <DocContent html={content.html} />
      </article>
    </Layout>
  );
}
